import {Component, OnInit, ViewChild} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import * as moment from 'moment';


@Component({
  selector: 'app-personal-information',
  templateUrl: './personal-information.component.html',
  styleUrls: [
    './../../../shared/style/main.scss',
    './../../../shared/style/form.scss',
    './personal-information.component.scss'
  ]
})
export class PersonalInformationComponent implements OnInit {
  public personalInformationForm = new FormGroup({
    'name': new FormControl('', Validators.required),
    'address': new FormControl('', Validators.required),
    'district': new FormControl('', Validators.required),
    'province': new FormControl('', Validators.required),
    'postCode': new FormControl('', Validators.required),
    'dateOfBirth': new FormControl('', Validators.required),
    'email': new FormControl('', [Validators.required, Validators.email]),
    'phoneNumber': new FormControl('', Validators.required)
  });

  public getformValue = {
    name: this.personalInformationForm.get('name'),
    address: this.personalInformationForm.get('address'),
    district: this.personalInformationForm.get('district'),
    province: this.personalInformationForm.get('province'),
    postCode: this.personalInformationForm.get('postCode'),
    dateOfBirth: this.personalInformationForm.get('dateOfBirth'),
    email: this.personalInformationForm.get('email'),
    phoneNumber: this.personalInformationForm.get('phoneNumber')
  };

  public submitButtonClicked: boolean;
  public formReadOnly: boolean;
  public formIsValid: boolean;
  public defaultPersonalInformation;

  @ViewChild('nameInPersionalInformationForm') nameInPersionalInformationForm;

  constructor() {
    this.submitButtonClicked = false;
    this.formReadOnly = true;
  }

  ngOnInit() {
    this.switchReadOnlyStatus(true);
    this.defaultPersonalInformation = {
      'name': '',
      'address': '',
      'district': '',
      'province': '',
      'postCode': '',
      'dateOfBirth': '',
      'email': '',
      'phoneNumber': ''
    };
    this.getformValue.name.patchValue(this.defaultPersonalInformation.name);
    this.getformValue.address.patchValue(this.defaultPersonalInformation.address);
    this.getformValue.district.patchValue(this.defaultPersonalInformation.district);
    this.getformValue.province.patchValue(this.defaultPersonalInformation.province);
    this.getformValue.postCode.patchValue(this.defaultPersonalInformation.postCode);
    this.getformValue.dateOfBirth.patchValue(this.defaultPersonalInformation.dateOfBirth);
    this.getformValue.email.patchValue(this.defaultPersonalInformation.email);
    this.getformValue.phoneNumber.patchValue(this.defaultPersonalInformation.phoneNumber);
  }

  submitForm(e) {
    e.preventDefault();
    this.submitButtonClicked = true;

    this.formIsValid = false;

    const formBasicValidationIsValid = (
      this.getformValue.name.valid ||
      this.getformValue.address.valid ||
      this.getformValue.district.valid ||
      this.getformValue.province.valid ||
      this.getformValue.postCode.valid ||
      this.getformValue.dateOfBirth.valid ||
      this.getformValue.email.valid ||
      this.getformValue.phoneNumber.valid
    );

    const validDateOfBirth = moment(this.getformValue.dateOfBirth.value, 'YYYY/MM/DD').isValid();
    if (validDateOfBirth) {
      this.getformValue.dateOfBirth.patchValue(this.checkDateOfBirth(this.getformValue.dateOfBirth.value));
    } else {
      this.getformValue.dateOfBirth.setErrors({incorrect: true});
    }

    this.getformValue.postCode.patchValue(this.checkNumeric(this.getformValue.postCode.value));
    const validPostCode = (this.getformValue.postCode.value !== '');
    if (!validPostCode) {
      this.getformValue.postCode.setErrors({incorrect: true});
    }

    this.getformValue.phoneNumber.patchValue(this.checkNumeric(this.getformValue.phoneNumber.value));
    const validPhoneNumber = (this.getformValue.phoneNumber.value !== '');
    if (!validPhoneNumber) {
      this.getformValue.phoneNumber.setErrors({incorrect: true});
    }

    this.formIsValid = (formBasicValidationIsValid && validDateOfBirth && validPostCode && validPhoneNumber);

    if (this.formIsValid) {
      // submit form

      /* After submit form is success : */
      this.switchReadOnlyStatus(true);
      this.defaultPersonalInformation = {
        'name': '',
        'address': '',
        'district': '',
        'province': '',
        'postCode': '',
        'dateOfBirth': '',
        'email': '',
        'phoneNumber': ''
      };

      /* If form submit is error : */
      /* show the error message */
    }
  }

  cancelFormEditing() {
    this.getformValue.name.patchValue(this.defaultPersonalInformation.name);
    this.getformValue.address.patchValue(this.defaultPersonalInformation.address);
    this.getformValue.district.patchValue(this.defaultPersonalInformation.district);
    this.getformValue.province.patchValue(this.defaultPersonalInformation.province);
    this.getformValue.postCode.patchValue(this.defaultPersonalInformation.postCode);
    this.getformValue.dateOfBirth.patchValue(this.defaultPersonalInformation.dateOfBirth);
    this.getformValue.email.patchValue(this.defaultPersonalInformation.email);
    this.getformValue.phoneNumber.patchValue(this.defaultPersonalInformation.phoneNumber);
    this.switchReadOnlyStatus(true);
  }

  checkNumeric(str: string) {
    const result = str.match(/\d+/g);

    return (result) ? result.join('') : '';
  }

  checkNumericInput(evt) {
    evt.path[0].value = this.checkNumeric(evt.path[0].value);
  }

  checkDateOfBirth(str: string) {
    const result = [];

    const arrSplit = str.split('');
    arrSplit.forEach((val: any) => {
      if (result.length < 10) {
        if (val == '/' && (result.length == 2 || result.length == 5)) {
          result.push(val);
        } else if (!isNaN(parseInt(val))) {
          if (result.length == 2 || result.length == 5) {
            result.push('/')
          }
          result.push(val);
        }
      }
    });

    return (result.length > 0) ? result.join('') : '';
  }

  checkDateOfBirthInput(evt) {
    evt.path[0].value = this.checkDateOfBirth(evt.path[0].value);
  }

  switchReadOnlyStatus(status) {
    this.formReadOnly = status;
    this.submitButtonClicked = false;
    if (status) {
      this.getformValue.name.disable();
      this.getformValue.address.disable();
      this.getformValue.district.disable();
      this.getformValue.province.disable();
      this.getformValue.postCode.disable();
      this.getformValue.dateOfBirth.disable();
      this.getformValue.email.disable();
      this.getformValue.phoneNumber.disable();
    } else {
      this.getformValue.name.enable();
      this.getformValue.address.enable();
      this.getformValue.district.enable();
      this.getformValue.province.enable();
      this.getformValue.postCode.enable();
      this.getformValue.dateOfBirth.enable();
      this.getformValue.email.enable();
      this.getformValue.phoneNumber.enable();
      this.nameInPersionalInformationForm.nativeElement.focus();
    }
  }
}
